export const API_URL = 'http://192.168.1.14:8008/api';
export const API_URL_AUTH = 'https://auth.ebslab.in/api';
